import { useEffect, useRef, useState } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

/** Exchanges the one-time Emergent session id for a Pramsia session, then lands on the app. */
export default function AuthCallback() {
  const { completeGoogleLogin } = useAuth();
  const [error, setError] = useState("");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      setError("Sign-in link is incomplete. Please try again.");
      return;
    }
    completeGoogleLogin(sessionId).then((res) => {
      window.history.replaceState(null, "", window.location.pathname);
      if (!res.ok) setError(res.error);
      else window.location.replace("/");
    });
  }, [completeGoogleLogin]);

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 px-6 text-center"
      data-testid="google-auth-callback">
      {error ? (
        <>
          <p className="max-w-sm text-sm text-destructive" data-testid="google-auth-error">{error}</p>
          <Button data-testid="google-auth-back" onClick={() => window.location.replace("/")}>
            Back to sign in
          </Button>
        </>
      ) : (
        <>
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
          <p className="text-sm text-muted-foreground">Signing you in…</p>
        </>
      )}
    </div>
  );
}
